import { getRealmId } from '@ragu-components/ord-providers';

import { getApTemplateDefaults } from './apTemplates';
import { replaceCallRecordingConfQueues } from './callRecordingConfs';
import { executeSchedule } from './schedules';
import {
  getTotp,
  createTotp,
  updatePassword,
  totpVerify,
  downloadFile,
  getUserSettings,
  updateUserSettings,
  getUserVoicemail,
  createUserVoicemail,
  updateUserVoicemail,
  getPersonalVoicemail,
  updatePersonalVoicemail,
  updateAutoprovisioningAuthentication,
  updateAutoprovisioningSettings,
  createBackup,
  createBackupImport,
  createBackupRestore,
  getCallForwardingSettings,
  updateCallForwardingSettings,
} from './settings';

import type { AxiosInstance } from 'axios';
import type { IngordDataProvider } from 'src/lib/types';

export const createCustomMethods = (axiosInstance: AxiosInstance): Partial<IngordDataProvider> => ({
  getUserSettings: async () => getUserSettings(axiosInstance, getRealmId()),
  updateUserSettings: async (params) => updateUserSettings(axiosInstance, params, getRealmId()),
  getTotp: async () => getTotp(axiosInstance, getRealmId()),
  createTotp: async (params) => createTotp(axiosInstance, params, getRealmId()),
  totpVerify: async (params) => totpVerify(axiosInstance, params, getRealmId()),
  updatePassword: async (params) => updatePassword(axiosInstance, params, getRealmId()),
  downloadFile: async (params) => downloadFile(axiosInstance, params, getRealmId()),
  getUserVoicemail: async (userId) => getUserVoicemail(axiosInstance, getRealmId(), userId),
  createUserVoicemail: async (userId, params) => createUserVoicemail(axiosInstance, getRealmId(), userId, params),
  updateUserVoicemail: async (userId, params) => updateUserVoicemail(axiosInstance, getRealmId(), userId, params),
  getPersonalVoicemail: async () => getPersonalVoicemail(axiosInstance, getRealmId()),
  updatePersonalVoicemail: async (params) => updatePersonalVoicemail(axiosInstance, getRealmId(), params),
  updateAutoprovisioningAuthentication: async (params) =>
    updateAutoprovisioningAuthentication(axiosInstance, getRealmId(), params),
  updateAutoprovisioningSettings: async (params) => updateAutoprovisioningSettings(axiosInstance, getRealmId(), params),
  getApTemplateDefaults: async () => getApTemplateDefaults(axiosInstance, getRealmId()),
  createBackup: async (domainId) => createBackup(axiosInstance, domainId, getRealmId()),
  createBackupImport: async (realm) => createBackupImport(axiosInstance, getRealmId(), realm),
  createBackupRestore: async (targetDomainId) => createBackupRestore(axiosInstance, getRealmId(), targetDomainId),
  replaceCallRecordingConfQueues: async (confId, queueIds) =>
    replaceCallRecordingConfQueues(axiosInstance, getRealmId(), confId, queueIds),
  executeSchedule: async (scheduleId) => executeSchedule(axiosInstance, getRealmId(), scheduleId),
  getCallForwardingSettings: async () => getCallForwardingSettings(axiosInstance, getRealmId()),
  updateCallForwardingSettings: async (rules) => updateCallForwardingSettings(axiosInstance, rules, getRealmId()),
});
